import type { ReactElement } from "react";

export enum EModalScreen {
    MAIN_SCREEN = "mainScreen",
    INVITATION_STATUS_SCREEN = "invitationStatusScreen",
}

export interface IRewardsModal {
    rewardsModalComponent: ReactElement;
    handleOpenModal: () => void;
}

export interface IInvitation {
    Email: string;
    Status: "pending" | "active";
    CreatedAt: string;
}

export interface IPackage {
    DiscountPercentage: number;
    ReferralsNumber: number;
}

export interface IRewardsOverview {
    Invitations: IInvitation[];
    Packages: IPackage[];
    PeopleRewardedThisMonth: number;
}
